import React from "react";
import { Route, Redirect, IndexRoute, IndexRedirect } from "react-router";
import { routes } from "oo-routes/public";

if (typeof require.ensure !== "function") {
  require.ensure = function (modules, cb) {
    cb(require);
  };
}

export default function createRoutes(store) {
  const pages = {
    HomePage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/HomePage2").default);
        });
      },
    },
    ScreenprintPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/ScreenprintPage").default);
        });
      },
    },
    DTGPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/DTGPage").default);
        });
      },
    },
    SublimationPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/SublimationPage").default);
        });
      },
    },
    PosterPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/PosterPage").default);
        });
      },
    },
    ApiPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/ApiPage").default);
        });
      },
    },
    WooCommercePage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/WooCommercePage").default);
        });
      },
    },
    ShopifyPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/ShopifyPage").default);
        });
      },
    },
    PricingPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/PricingPage").default);
        });
      },
    },
    CareersPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/CareersPage").default);
        });
      },
    },
    CatalogPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/CatalogPage").default);
        });
      },
    },
    RegisterPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/RegisterPage").default);
        });
      },
    },
    LoginPage: {
      getComponent: (nextState, cb) => {
        require.ensure([], (require) => {
          cb(null, require("../pages/LoginPage").default);
        });
      },
    },
  };

  function route(page, path) {
    const props = {
      path,
      getComponent: page.getComponent,
    };

    if (path) {
      return <Route {...props} />;
    }
    return <IndexRoute {...props} />;
  }

  return (
    <Route
      path={routes.website2.home.base}
      component={require("../pages/Layout").default}
    >
      {route(pages.HomePage)}
      {/* these pages should be rendered by sp-website-legacy
      {route(pages.ScreenprintPage, routes.website2.home.screenprint)}
      {route(pages.DTGPage, routes.website2.home.dtg)}
      {route(pages.SublimationPage, routes.website2.home.sublimation)}
      {route(pages.PosterPage, routes.website2.home.poster)}
      {route(pages.ApiPage, routes.website2.home.api)}
      {route(pages.WooCommercePage, routes.website2.home.woocommerce)}
      {route(pages.ShopifyPage, routes.website2.home.shopify)}
      */}
      {route(pages.PricingPage, routes.website2.home.pricing)}
      {route(pages.CareersPage, routes.website2.home.careers.base)}
      {route(pages.CareersPage, routes.website2.home.jobs)}
      {route(pages.CatalogPage, routes.website2.home.catalog)}
      {route(pages.RegisterPage, routes.website2.home.auth.register)}
      {route(pages.LoginPage, routes.website2.home.auth.login)}
    </Route>
  );
}



// WEBPACK FOOTER //
// ./app/routes/index.jsx